import { HelpIcon } from '../../../../../../shared/components/icons/nav/HelpIcon'
import { BpAnchor } from '../../../../../../shared/components/text/anchor/BpAnchor'
import { BpButton } from '../../../../../../shared/components/buttons/bp-button/BpButton'
import { selectShowGuide, setModal } from '../../../../../store/reducers/AppSlice'
import { FeedbackModal } from '../../../ui/FeedbackModal'
import { CardDrop } from '../../../../../../shared/components/cards/card-drop/CardDrop'
import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks/Redux'
import { BpPopconfirm } from '../../../../../../shared/components/cards/popconfirm/BpPopconfirm'
import { GuideModal } from '../../../ui/GuideModal'
import { removeNotification, selectUser } from '../../../../../store/reducers/AuthSlice'
import {
  useGetSiteArticleSettingsQuery,
  usePostSiteHideNotificationMutation,
} from '../../../../../api'
import { useTranslation } from 'react-i18next'

export const HelpButton = () => {
  const { t } = useTranslation()
  const user = useAppSelector(selectUser)
  const showGuide = useAppSelector(selectShowGuide)
  const [isCardDropOpen, setIsCardDropOpen] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const dispatch = useAppDispatch()

  const { data } = useGetSiteArticleSettingsQuery()
  const [hideNotification] = usePostSiteHideNotificationMutation()

  useEffect(() => {
    const notification = user.notifications?.find(
      (notification) => notification.type === 'onboarding_tutorial',
    )

    if (notification && !notification.is_hidden) {
      setTimeout(() => setShowConfirm(true), 1000)
    }
  }, [user])

  useEffect(() => {
    setIsCardDropOpen(false)

    if (showGuide) {
      setTimeout(() => setIsCardDropOpen(true))
    }
  }, [showGuide])

  const hideNotify = () => {
    const notification = user.notifications?.find(
      (notification) => notification.type === 'onboarding_tutorial',
    )

    if (notification) {
      hideNotification({ id: notification.id })
      dispatch(removeNotification(notification.type))
    }

    setShowConfirm(false)
  }

  return (
    <BpPopconfirm
      arrowPointAtCenter
      title={
        <p>
          {t('components.guideButton.preparedQuickGuide')}
          <ul className={'list-disc pl-[16px]'}>
            <li>{t('components.guideButton.competitorAnalysis')}</li>
            <li>{t('components.guideButton.nonCompliantAffiliates')}</li>
            <li>{t('components.guideButton.projectManagement')}</li>
            <li>{t('components.guideButton.workWithUsersTeam')}</li>
          </ul>
          {t('components.guideButton.wouldLearnMore')}
        </p>
      }
      cancelText={t('buttons.later')}
      okText={t('buttons.seeQuickGuide')}
      open={showConfirm}
      overlayClassName={'w-[300px]'}
      placement={'bottomRight'}
      onConfirm={() => {
        hideNotify()
        setIsCardDropOpen(true)
      }}
      onCancel={hideNotify}
    >
      <CardDrop
        trigger={
          <div
            className={'relative flex items-center rounded-[18px] border border-aqua-300 p-[2px]'}
          >
            <div className='flex h-[32px] w-[32px] items-center justify-center rounded-full text-white hover:bg-[#6684A74D]'>
              <HelpIcon />
            </div>
            <div
              className={`pointer-events-none absolute -left-[25%] -top-[25%] h-[150%] w-[150%] rounded-full border-[2px] border-dashed border-default transition-opacity duration-200 ${showConfirm ? 'opacity-1' : 'opacity-0'} `}
            ></div>
          </div>
        }
        className={'!top-[50px]'}
        opened={isCardDropOpen}
        onToggle={hideNotify}
      >
        <div className={'min-w-[230px] py-[16px]'}>
          <div className={'flex flex-col px-[16px] pb-[6px]'}>
            {process.env.REACT_APP_PROJECT === 'bluepear' && (
              <button
                className={
                  'rounded-[8px] p-[8px] text-left text-[15px] !text-focus-500 hover:bg-default-200 hover:!text-default'
                }
                onClick={() =>
                  dispatch(
                    setModal({
                      id: 'guide-modal',
                      size: 'xl',
                      scroll: true,
                      children: <GuideModal />,
                    }),
                  )
                }
              >
                {t('components.guideButton.quickGuide')}
              </button>
            )}
            {data?.data?.items?.articles?.map(({ name, url }, index) => (
              <BpAnchor
                key={index}
                className={
                  'rounded-[8px] p-[8px] text-[15px] !text-focus-500 hover:bg-default-200 hover:!text-default'
                }
                href={url}
                target='_blank'
              >
                {name}
              </BpAnchor>
            ))}
          </div>
          <div className={'flex flex-col gap-[12px] bg-[#0E63D8]/[0.05] px-[24px] py-[16px]'}>
            <p className={'text-center text-[17px] font-medium'}>
              {t('components.guideButton.askSpecialist')}
            </p>
            {data?.data?.items?.buttons?.map(({ name, url }, index) => (
              <BpButton key={index} size={'sm'} onClick={() => window.open(url, '_blank')}>
                {name}
              </BpButton>
            ))}
            <div className={'flex justify-center gap-[6px]'}>
              {data?.data?.items?.contacts?.map(({ name, url }, index) => (
                <BpAnchor key={index} className={'text-[15px]'} href={url} target='_blank'>
                  {name}
                </BpAnchor>
              ))}
            </div>
          </div>
          {data?.data?.items?.feedback && (
            <div className={'flex px-[16px] pt-[16px]'}>
              <button
                className={
                  'm-auto w-fit text-[15px] text-[#0E63D8] transition-opacity duration-150 hover:text-[#40a9ff] hover:opacity-80'
                }
                onClick={() => dispatch(setModal({ children: <FeedbackModal /> }))}
              >
                {t('components.guideButton.giveFeedback')}
              </button>
            </div>
          )}
        </div>
      </CardDrop>
    </BpPopconfirm>
  )
}
